import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Login from "./components/Login";
import Header from "./components/Header";
import Home from "./components/Home";
import Detail from "./DetailPages/Detail";
import NewDetail from "./DetailPages/NewDetail";
import OriginalDetail from "./DetailPages/OriginalDetail";
import TrendingDetail from "./DetailPages/TrendingDetail";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route exact path="/" element={<Login />}></Route>
          <Route exact path="/home" element={<Home />}></Route>
          <Route exact path="/detail/:id" element={<Detail />}></Route>
          <Route exact path="/newdetail/:id" element={<NewDetail />}></Route>
          <Route exact path="/originaldetail/:id" element={<OriginalDetail />}></Route>
          <Route exact path="/trendingdetail/:id" element={<TrendingDetail />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
